import { render, staticRenderFns } from "./title-style1.vue?vue&type=template&id=0741cde2&scoped=true&"
import script from "./title-style1.vue?vue&type=script&lang=ts&"
export * from "./title-style1.vue?vue&type=script&lang=ts&"
import style0 from "./title-style1.vue?vue&type=style&index=0&id=0741cde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0741cde2",
  null
  
)

export default component.exports